import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DraggableModalWrapperComponent } from '../modal/draggable-modal-wrapper/draggable-modal-wrapper.component';
import { ModalData } from '../modal/models/modal-data';

@Component({
    selector: 'app-checkmark-dialog',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        MatButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        DraggableModalWrapperComponent,
        MatDialogClose,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: `./checkmark-dialog.component.html`,
})
export class CheckmarkDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ModalData) {}
}
